
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"6.544 2.951 11.76 13.72","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.194 15.69l-4.77-12c-.15-.39-.38-.74-1-.74-.49 0-.78.21-.98.74l-4.79 11.99c-.07.15-.11.31-.11.37 0 .31.2.62.64.62.35 0 .55-.15.69-.5l1.25-3.05h6.6l1.21 3.05c.13.34.34.5.69.5.41 0 .68-.24.68-.62-.02-.08-.05-.26-.11-.36zm-8.78-3.63l2.99-7.5 2.99 7.5h-5.98z","fill":"#007f32"}})])
          )
        }
      }
    